import React, { useState } from 'react';
import SwapPuzzle from '../puzzle/SwapPuzzle';


export const StagePuzzle = ({meeting, onNextStage=f=>f})=>{
    //퍼즐의 완료여부
    const [puzzleEnd, setPuzzleEnd] = useState(false);

    //이건 표지주소가 로컬이거나 또는 외부(전체주소)일 경우를 주소 처리
    const coverImage = (null!==meeting.meeting.cover && meeting.meeting.cover.startsWith('http://') )?`${meeting.meeting.cover}`:meeting.meeting.cover;
    function onPuzzleFinish () {
        setPuzzleEnd(true)
    }
    // 퍼즐이 완료되면 puzzleEnd=true로 변경
    // puzzleEnd===true면 PuzzleFinishModal를 생성
    return (
        <div className="puzzleBoard">
            { puzzleEnd && <PuzzleFinishModal onNextStage={onNextStage} /> }
            <SwapPuzzle startDelay={5}  onPuzzleFinish={onPuzzleFinish} imageUrl={coverImage}  />
        </div>
    );
    
}

const PuzzleFinishModal = ({ onNextStage=f=>f})=>{
    return (
        <div className="modal">
            <div className="modal_cont">
                <img src={`${process.env.PUBLIC_URL}/static/images/meeting/puzzleModalBookgomi.png`} alt="훌륭해요! 퍼즐을 완성했어요."/>
                <h3>훌륭해요!</h3>
                <p>퍼즐을 완성했어요.</p>
                <button type="button" className="btn _blue" onClick={onNextStage}>다음 단계</button>
            </div>
        </div>
    )
};
